import { useEffect, useState } from "react";

export default function useFormDraft(key, initialState) {

  const [formData, setFormData] = useState(() => {

    const saved = localStorage.getItem(key);

    return saved ? JSON.parse(saved) : initialState;

  });

  useEffect(() => {

    localStorage.setItem(key, JSON.stringify(formData));

  }, [formData, key]);

  const clearDraft = () => {

    localStorage.removeItem(key);

    setFormData(initialState);

  };

  return {
    formData,
    setFormData,
    clearDraft
  };

}